import angular from 'angular';
import Logger from '../shared/logger';

export const SemiDynamicMetadataService = (Restangular) => {
    const getSemiDynamicMetadata = requestBody =>
        Restangular.all('metadata')
            .all('semiDynamicLookups')
            .post(requestBody)
            .catch(error => Logger.error(error));

    const getLocations = ({ text = '', selected = [], maxItems = 8 }) => {
        const requestBody = {
            currentField: {
                field: 'locations',
                type: 'Text',
                value: text,
                matchType: 'contains',
            },
            maxItems,
            searchCountries: [],
            searchLanguages: [],
            selected,
        };

        return getSemiDynamicMetadata(requestBody);
    };

    return {
        getSemiDynamicMetadata,
        getLocations,
    };
};

angular.module('TALENYA-FE').factory('SemiDynamicMetadataService', SemiDynamicMetadataService);
